import React from 'react';

import { Field } from 'redux-form';
import classnames from 'classnames';

import renderToggle from 'shared/forms/renderToggle';

import styles from './styles.module.scss';

const PreferenceElement = ({
  title,
  label,
  fieldName,
  onChange,
  className
}) => (
  <div className={classnames(styles.preferenceElementWrapper, className)}>
    <div>
      <div className={styles.title}>{title}</div>
      <div className={styles.label}>{label}</div>
    </div>
    <div className={styles.toggle}>
      <Field
        className="form-control"
        name={fieldName}
        component={renderToggle}
        onChange={onChange}
      />
    </div>
  </div>
);

export default PreferenceElement;
